document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.eckberg-products-menu');
  if (!menu) return;
  const details = menu.querySelector(':scope > details');
  const summary = details?.querySelector(':scope > summary');
  if (!details || !summary) return;

  const desktop = () => window.matchMedia('(min-width: 990px)').matches;
  let closeTimer;

  menu.addEventListener('mouseenter', () => {
    if (!desktop()) return;
    clearTimeout(closeTimer);
    details.setAttribute('open', '');
    summary.setAttribute('aria-expanded', 'true');
  });

  menu.addEventListener('mouseleave', () => {
    if (!desktop()) return;
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    }, 120);
  });
});

/* =================================================================
   ECKBERG — kívánságlista és partnerkereső
   =================================================================
   Mindkettő alkalmazás nélkül működik. A kívánságlista a böngésző
   tárolójában él (localStorage), a partnerkereső pedig a lapon már
   ott lévő listát szűri — se hálózat, se újratöltés.
   ================================================================= */
(function () {
  'use strict';

  var KULCS = 'eckberg:wishlist';

  /* A feliratok a lapba ágyazott nyelvi blokkból jönnek (theme.liquid),
     hogy az angol változatban ne maradjon magyar szöveg. Ha a blokk
     bármiért hiányzik, a magyar tartalék megy — nem üres gomb. */
  var SZOVEG = (function () {
    var alap = { hozzaad: 'Kívánságlistára', rajta: 'Kívánságlistán',
                 leveszem: 'Leveszem', hely: '%DB% hely' };
    try {
      var el = document.getElementById('eck-i18n');
      if (!el) return alap;
      var be = JSON.parse(el.textContent);
      for (var k in alap) { if (be[k]) alap[k] = be[k]; }
      return alap;
    } catch (e) { return alap; }
  })();

  /* A tároló bármikor elérhetetlen lehet (privát ablak, letiltott
     sütik, beágyazott nézet). Ilyenkor a lista egyszerűen üres marad,
     és semmi nem törik el — ezért van minden hozzáférés try/catch-ben. */
  function olvas() {
    try {
      var nyers = window.localStorage.getItem(KULCS);
      var tomb = nyers ? JSON.parse(nyers) : [];
      return Array.isArray(tomb) ? tomb.filter(function (x) { return typeof x === 'string'; }) : [];
    } catch (e) {
      return [];
    }
  }

  function ir(tomb) {
    try {
      window.localStorage.setItem(KULCS, JSON.stringify(tomb));
    } catch (e) { /* tele van vagy tiltva — a lap ettől még működik */ }
  }

  function szamlaloFrissit() {
    var db = olvas().length;
    document.querySelectorAll('[data-eck-wish-count]').forEach(function (el) {
      el.textContent = db;
      el.hidden = db === 0;
    });
  }

  /* A gombok kezdetben „nincs rajta" állapotban jönnek a szerverről,
     mert a szerver nem látja a böngésző tárolóját (és a Shopify a
     lapokat gyorsítótárazza). Itt javítjuk ki őket. */
  function gombokFrissit() {
    var lista = olvas();
    document.querySelectorAll('[data-eck-wish]').forEach(function (gomb) {
      var rajta = lista.indexOf(gomb.dataset.eckWish) !== -1;
      gomb.setAttribute('aria-pressed', rajta ? 'true' : 'false');
      var cimke = gomb.querySelector('[data-eck-wish-label]');
      if (cimke) cimke.textContent = rajta ? SZOVEG.rajta : SZOVEG.hozzaad;
    });
  }

  document.addEventListener('click', function (esemeny) {
    var gomb = esemeny.target.closest('[data-eck-wish]');
    if (!gomb) return;
    esemeny.preventDefault();
    var azonosito = gomb.dataset.eckWish;
    var lista = olvas();
    var hol = lista.indexOf(azonosito);
    if (hol === -1) { lista.push(azonosito); } else { lista.splice(hol, 1); }
    ir(lista);
    gombokFrissit();
    szamlaloFrissit();
  });

  /* ---- a kívánságlista oldal ---- */

  /* A terméknevet szövegként rakjuk a lapra, nem HTML-ként: egy „&"
     vagy egy idézőjel a névben („Pienaar & Son") különben elrontaná a
     jelölést. */
  function szoveggeAlakit(s) {
    var d = document.createElement('span');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  /* Ugyanaz az alak, mint a bolt pénzformátuma: „8.490 Ft". */
  function penz(fillerek) {
    var ft = Math.round(fillerek / 100);
    return String(ft).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '\u00a0Ft';
  }

  function listaOldal() {
    var racs = document.querySelector('[data-eck-wishpage-grid]');
    if (!racs) return;
    var ures = document.querySelector('[data-eck-wishpage-empty]');
    var toltes = document.querySelector('[data-eck-wishpage-loading]');
    var azonositok = olvas();

    if (toltes) toltes.hidden = true;
    if (!azonositok.length) {
      if (ures) ures.hidden = false;
      return;
    }
    if (toltes) toltes.hidden = false;

    /* Minden tételt a Shopify saját termék-végpontjáról kérünk le.
       Ha egy termék időközben eltűnt, csendben kihagyjuk — nem
       hibaüzenetet mutatunk, hanem egyszerűen nincs ott. */
    Promise.all(azonositok.map(function (h) {
      return fetch(window.Shopify.routes.root + 'products/' + h + '.js')
        .then(function (v) { return v.ok ? v.json() : null; })
        .catch(function () { return null; });
    })).then(function (termekek) {
      var eleok = termekek.filter(Boolean);
      if (toltes) toltes.hidden = true;
      if (!eleok.length) { if (ures) ures.hidden = false; return; }

      racs.hidden = false;
      racs.innerHTML = eleok.map(function (t) {
        var kep = t.featured_image
          ? '<img class="eck-wishcard__kep" src="' + t.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') +
            '" alt="" loading="lazy" width="400" height="400">'
          : '<span class="eck-wishcard__kep"></span>';
        return '<article class="eck-wishcard">' +
          '<a href="' + window.Shopify.routes.root + 'products/' + t.handle + '">' + kep + '</a>' +
          '<p class="eck-wishcard__nev"><a href="' + window.Shopify.routes.root + 'products/' + t.handle + '">' +
          szoveggeAlakit(t.title) + '</a></p>' +
          '<p class="eck-wishcard__ar">' + penz(t.price) + '</p>' +
          '<button type="button" class="eck-wishcard__le" data-eck-wish-remove="' + t.handle + '">' + SZOVEG.leveszem + '</button>' +
          '</article>';
      }).join('');
    });
  }

  document.addEventListener('click', function (esemeny) {
    var le = esemeny.target.closest('[data-eck-wish-remove]');
    if (!le) return;
    var lista = olvas().filter(function (h) { return h !== le.dataset.eckWishRemove; });
    ir(lista);
    szamlaloFrissit();
    var kartya = le.closest('.eck-wishcard');
    if (kartya) kartya.remove();
    if (!lista.length) {
      var racs = document.querySelector('[data-eck-wishpage-grid]');
      var ures = document.querySelector('[data-eck-wishpage-empty]');
      if (racs) racs.hidden = true;
      if (ures) ures.hidden = false;
    }
  });

  /* ---- partnerkereső ---- */

  function partnerKereso() {
    var mezo = document.querySelector('[data-eck-locator-input]');
    if (!mezo) return;
    var tetelek = Array.prototype.slice.call(document.querySelectorAll('[data-eck-locator-item]'));
    var db = document.querySelector('[data-eck-locator-count]');
    var nincs = document.querySelector('[data-eck-locator-empty]');

    function szur() {
      /* Ékezetek nélkül hasonlítunk, hogy a „szeged" is találjon a
         „Szeged"-re, és a „gyor" a „Győr"-re. */
      var q = mezo.value.trim().toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      var talalat = 0;
      tetelek.forEach(function (t) {
        var szoveg = (t.dataset.kereses || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        var latszik = !q || szoveg.indexOf(q) !== -1;
        t.hidden = !latszik;
        if (latszik) talalat++;
      });
      if (db) db.textContent = SZOVEG.hely.replace('%DB%', talalat);
      if (nincs) nincs.hidden = talalat !== 0;
    }

    mezo.addEventListener('input', szur);
    szur();
  }

  function indul() {
    gombokFrissit();
    szamlaloFrissit();
    listaOldal();
    partnerKereso();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', indul, { once: true });
  } else {
    indul();
  }

  /* A kosár-oldalsáv és a szűrők a lap egy részét kicserélik; ilyenkor
     az új gombokra újra rá kell írni az állapotot. */
  document.addEventListener('shopify:section:load', indul);
  document.addEventListener('cart:refresh', gombokFrissit);
  /* A megfigyelő csak azt nézi, került-e új csomópont a lapra (szűrés,
     kosár-oldalsáv, gyors kosárba). Egy képkockán belül egyszer fut le,
     különben egy nagy lista kirajzolásakor százszor hívnánk meg. */
  var varakozik = false;
  new MutationObserver(function (valtozasok) {
    if (varakozik) return;
    for (var i = 0; i < valtozasok.length; i++) {
      if (valtozasok[i].addedNodes.length) {
        varakozik = true;
        window.requestAnimationFrame(function () { varakozik = false; gombokFrissit(); });
        return;
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
